/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-restricted-imports */

import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
  OnDestroy,
  Inject,
} from '@angular/core';
import * as uuid from 'uuid';
import { Router } from '@angular/router';
import {
  getAdobeSiteSection,
  GroupItem,
  Menu,
} from '@cigna/cigna-for-brokers/shared/util';
import {
  AppstateFacade,
  Clients,
  DELEGATION_LEVEL,
  NavigationResponse,
  USER_TYPE,
} from '@cigna/cigna-for-brokers/shell/data-access';
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { HeaderProfileService } from '../+state/header-profiel.service';
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import { MatMenuTrigger } from '@angular/material/menu';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import includes from 'lodash/includes';
import { ContactUsComponent } from '@cigna/cigna-for-brokers/shared/ui';
import { Roles } from '../+state/menu-nav.models';
import {
  GatewayConfig,
  GATEWAY_CONFIG,
} from '@cigna/cigna-for-brokers/shared/gateways';
import { TranslateService } from '@ngx-translate/core';
import { get } from 'lodash';

@Component({
  selector: 'cigna-caheader-secure',
  templateUrl: './header-secure.component.html',
  styleUrls: ['./header-secure.component.scss'],
})
export class HeaderSecureComponent implements OnInit, OnChanges, OnDestroy {
  @Output() toggleSideMenu = new EventEmitter();

  @Input() firstName: string;
  @Input() lastName: string;
  @Input() internalFirstName: string;
  @Input() internalLastName: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() loading: boolean;
  @Input() groupItems: GroupItem[];
  @Input() searchedGroupItems: GroupItem[];
  @Input() searchByList: Array<{ id: string; name: string }>;
  @Input() defaultClientid: string;
  @Input() source: string | undefined;
  @Input() isImpersonatorFlag: boolean | undefined;
  @Input() navigation: NavigationResponse | undefined;

  @Output() logout = new EventEmitter<void>();
  @Output() secureMessage = new EventEmitter<{ url: string; target: string }>();
  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleTheme = new EventEmitter<void>();
  @Output() toggleDir = new EventEmitter<void>();
  @Output() clientChange = new EventEmitter<GroupItem>();
  @Output() internalClientChange = new EventEmitter<GroupItem>();
  @Output() searchClient = new EventEmitter<{
    searchType: string;
    searchValue: string;
  }>();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  sideBarToggleFlag: boolean;
  isDisplayClientLabel = true;
  isFirstTimeAlertStatus = true;
  // new list from left nav
  @Input() menuItemsWithSubMenu?: Menu[];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() resizeSideNavToggle: boolean;
  isLinkEnabled: boolean;
  @Input() isScreenSmall: boolean;
  @Input() navigationEntitlements: string[] | undefined;
  @Output() openExternalPage = new EventEmitter<{ source: string }>();
  @Input() isBillpayEnabled: boolean;
  @Input() isBillpayFacetsEnabled: boolean;
  @Input() isGovNonFacetsEnabled: boolean;
  @Input() isGovFacetsEnabled: boolean;
  @Input() isIncentiveEnabled: boolean;
  @Input() isCoverageTransparencyEnabled: boolean;
  @Input() isArchvdRptEnalbed: boolean;
  @Input() isSideBarToggleFlag: boolean;
  @Input() currentUrlPath: string;
  isCloseIconClicked = false;
  hasSecurityProfile: boolean | undefined;
  hasContactInfo: boolean | undefined;
  hasLogout: boolean | undefined;
  isIfpAEnabled: boolean;
  isSecurityProfileEnabled: boolean;
  isUsEmployerOnly = false;
  envName: string;
  isNspFeatureEnabledFlag = false;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  dWidth = '60rem';

  isIfpAdminEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isIfpAdminEnabled',
  ]);
  isSecurityProfileEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isSecurityProfileEnabled',
  ]);
  did0830ChangesEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'did0830ChangesEnabled',
  ]);
  roles$ = this.appstateFacade.roles$;
  hasUSE = false;
  hasSGP = false;
  hasMA = false;
  hasCSB = false;
  hasIFP = false;
  isUseOnly = false;
  isMaCsbOnly = false;
  roles: Roles[] = [];

  @ViewChild(MatMenuTrigger) matMenuTrigger: MatMenuTrigger;

  isFromBRPortal = true;

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private appstateFacade: AppstateFacade,
    public dialog: MatDialog,
    public _service: HeaderProfileService,
    private analytics: ShellTrackHandlers,
    private featureTogglesFacade: FeatureTogglesFacade,
    private translate: TranslateService,
    @Inject(GATEWAY_CONFIG) private _config: GatewayConfig,
  ) {
    this.firstName = 'test';
    this.lastName = 'test';

    this.start();
  }
  ngOnChanges(_changes: SimpleChanges): void {
    if (this.isFirstTimeAlertStatus) {
      this.isFirstTimeAlertStatus = false;
    }
    this.isUsEmployerOnly =
      this.menuItemsWithSubMenu
        ?.filter((menuItem) => menuItem.entitlement !== 'menu-dashboard')
        ?.every(
          (menuItem) => menuItem.entitlement === 'menu-commercial-plans',
        ) || false;
  }

  getUserType(userTypeCd: string) {
    const userType = USER_TYPE.find((type) => type.code === userTypeCd);
    if (userType) {
      return userType.description;
    }
    return '';
  }
  getDelegationLevel(delegationLevelCode: number) {
    const delegationLevel = DELEGATION_LEVEL.find(
      (item) => item.code === delegationLevelCode,
    );
    if (delegationLevel) {
      return delegationLevel.description;
    }
    return '';
  }

  ngOnInit(): void {
    this.isIfpAdminEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isIfpAEnable) => {
        this.isIfpAEnabled = isIfpAEnable;
      });
    this.isSecurityProfileEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isSPEnabled) => {
        this.isSecurityProfileEnabled = isSPEnabled;
      });

    if (this.isIfpAEnabled) {
      this.hasSecurityProfile =
        this.navigationEntitlements?.includes('security-profile');
      this.hasContactInfo =
        this.navigationEntitlements?.includes('contact-info');
      this.hasLogout = this.navigationEntitlements?.includes('logout');
    } else {
      this.hasSecurityProfile = true;
      this.hasContactInfo = true;
      this.hasLogout = true;
    }
  }

  isFundingSolution(currentUrlPath: string) {
    return currentUrlPath === '/secure/commercial/funding';
  }

  isContactUsIntuitive(currentUrlPath: string) {
    return includes(currentUrlPath, '/secure/contact-us');
  }

  toggleSideMenuFn() {
    this.sideBarToggleFlag = !this.sideBarToggleFlag;
    this.toggleSideMenu.emit(this.sideBarToggleFlag);
  }
  navigateSecureMessage(): void {
    const url = `${
      window.location.origin
    }/router/secure_email/secure/client?service_reference_id=${uuid.v4()}`;
    this.secureMessage.next({ url, target: '_blank' });
  }
  processLogout(): void {
    if (!this.isImpersonatorFlag) {
      this.analytics.trackEventOther({}, 'Logout', 'ac24438', {
        eVar119: 'MTD-1460',
        eVar120: 'profile-header',
        prop67: 'action',
        channel: getAdobeSiteSection(this.router.url).channel,
        pageName: getAdobeSiteSection(this.router.url).pageName,
        prop20: 'top-profile-menu',
      });
      this.logout.next();
    }
  }
  navigateSecureMessageLayout(data: { url: string; target: string }) {
    this.appstateFacade.windowOpen(data);
  }
  appRedirect(data: { redirect: string }) {
    this.appstateFacade.appRedirect(data);
  }
  profileContactUS() {
    if (!this.isImpersonatorFlag) {
      this.analytics.trackEventOther({}, 'Contact Us', 'ac24438', {
        eVar119: 'MTD-1460',
        eVar120: 'profile-header',
        prop67: 'action',
        channel: getAdobeSiteSection(this.router.url).channel,
        pageName: getAdobeSiteSection(this.router.url).pageName,
        prop20: 'top-profile-menu',
      });
    }

    this.did0830ChangesEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((did0830ChangesEnabled) => {
        if (did0830ChangesEnabled) {
          this.router.navigate(['/secure/home/contact-us']);
        } else {
          if (this.isImpersonatorFlag) {
            this.dWidth = '40rem';
          }

          this.dialog.open(ContactUsComponent, {
            width: this.dWidth,
            autoFocus: false,
            disableClose: true,
          });
        }
      });
  }
  securityProfile(): void {
    // get flag from resource bundle
    this.envName = this._config.environmentName;
    const featureFlagBase = this.translate.instant(`featureFlag`);

    const flagObj = get(featureFlagBase, this.envName);
    this.isNspFeatureEnabledFlag = get(
      flagObj,
      'isNewSecurityProFeatureEnabled',
    );

    if (this.isSecurityProfileEnabled && !this.isImpersonatorFlag) {
      this.analytics.trackEventOther({}, 'Security Profile', 'ac24438', {
        eVar119: 'MTD-1460',
        eVar120: 'profile-header',
        prop67: 'action',
        channel: getAdobeSiteSection(this.router.url).channel,
        pageName: getAdobeSiteSection(this.router.url).pageName,
        prop20: 'top-profile-menu',
      });
      if (this.isUseOnly && this.isNspFeatureEnabledFlag) {
        this.router.navigateByUrl('/secure/new-security-profile');
      } else {
        this.router.navigateByUrl('/secure/security-profile');
      }
    } else {
      this.analytics.trackEventOther({}, 'Security Profile', 'ac24438', {
        eVar119: 'MTD-1460',
        eVar120: 'profile-header',
        prop67: 'action',
        channel: getAdobeSiteSection(this.router.url).channel,
        pageName: getAdobeSiteSection(this.router.url).pageName,
        prop20: 'top-profile-menu',
      });
      this._service.getBrokerSecurityProfileUrl();
    }
  }
  closeMenu() {
    this.matMenuTrigger.closeMenu();
  }
  closeIcon() {
    this.isCloseIconClicked = true;
    // this.menuTrigger.closeMenu();
  }

  ngOnDestroy() {
    this.stop();
  }

  start(): void {
    window.addEventListener('storage', this.storageEventListener.bind(this));

    this.roles$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((resroles) => {
      if (resroles) {
        resroles.forEach((roleitem) => {
          if (roleitem.lob === 'IFP') {
            this.hasIFP = true;

            const isRoleExist = this.roles.some(
              (role) => role.producerCode === roleitem.producerCode,
            );
            if (!isRoleExist) {
              this.roles.push(roleitem);
            }
          } else if (roleitem.lob === 'CSB') {
            this.hasCSB = true;
          } else if (roleitem.lob === 'MA') {
            this.hasMA = true;
          } else if (roleitem.lob === 'SGP') {
            this.hasSGP = true;
          } else if (roleitem.lob === 'COMMERCIAL') {
            this.hasUSE = true;
          }
        });
      }
    });

    if (
      this.hasUSE &&
      !this.hasSGP &&
      !this.hasMA &&
      !this.hasCSB &&
      !this.hasIFP
    ) {
      this.isUseOnly = true;
    }

    if (
      this.hasUSE &&
      !this.hasSGP &&
      !this.hasIFP &&
      (this.hasMA || this.hasCSB)
    ) {
      this.isUseOnly = true;
    }
  }

  stop(): void {
    window.removeEventListener('storage', this.storageEventListener.bind(this));
  }

  storageEventListener(event: StorageEvent) {
    if (event.storageArea === localStorage) {
      if (event?.key && event.key === 'logout-event') {
        this.processLogout();
      }
    }
  }

  getMyMessages() {
    if (!this.isImpersonatorFlag) {
      const adobeSection = getAdobeSiteSection(this.router.url);
      this.analytics.trackEventOther({}, 'My Messages', 'ac24432', {
        eVar119: 'MTD-4816',
        eVar120: 'my-messages-link',
        prop67: 'action',
        channel: adobeSection.channel,
        pageName: adobeSection.pageName,
        prop20: 'header',
      });
    }
  }
}
